import React, { Component } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bool, shape, string } from "prop-types";

import { resizableRoute } from "pages/_components/Resizable";
import { selectors as sessionSelectors } from "reducers/session";

import Error from "pages/error/Error";
import ServerError from "pages/error/ServerError";
import LanguageSelection from "pages/login/LanguageSelection";
import RegionSelection from "pages/login/RegionSelection";
import ProductRequest from "pages/productRequest/ProductRequest";
import CreditCardStep1 from "pages/productRequest/creditCard/CreditCardStep1";
import CreditCardStep2 from "pages/productRequest/creditCard/CreditCardStep2";
import AssistantLogin from "pages/login/AssistantLogin";
import LoginStep2 from "pages/login/LoginStep2";
import LoginRegister from "pages/onboarding/LoginUser/LoginRegister";
import LoginStep3 from "pages/login/LoginStep3";
import LoginStep4 from "pages/login/LoginStep4";
import LoginStep6 from "pages/login/LoginStep6";
import LoginAssistantStep from "pages/login/LoginStep5";
import NoUser from "pages/login/NoUser";
import RecoveryPassStep1 from "pages/recoveryPassword/RecoveryPassStep1";
import RecoveryPassStep2 from "pages/recoveryPassword/RecoveryPassStep2";
import RecoveryPassStep3 from "pages/recoveryPassword/RecoveryPassStep3";
import RecoveryPassStep4 from "pages/recoveryPassword/RecoveryPassStep4";
import ExpiredByMaxAttempts from "pages/session/expiredByMaxAttempts";
import BackofficeTransaction from "pages/forms/BackofficeTransaction";
import BackofficeLayout from "pages/_layouts/BackofficeLayout";
import ExternalLayout from "pages/_layouts/ExternalLayout";
import EnrollmentLayout from "pages/_layouts/EnrollmentLayout";
import ProductRequestLayout from "pages/_layouts/ProductRequestLayout";
import OnboardingError from "pages/onboarding/_components/Error";
import OnboardingSafariSuggestionPage from "pages/onboarding/_components/SafariSuggestionPage";
import Processing from "pages/onboarding/_components/Processing";
import OnboardingPage from "pages/onboarding";
import TokenVirtual from "pages/accounts/_components/2FaSoftToken/TokenVirtual";
import OnboardingStep0 from "pages/onboarding/_pages/Step0";
import OnboardingStepCIP from "pages/onboarding/_pages/StepCIP";
import OnboardingStep1 from "pages/onboarding/_pages/Step1";
import OnboardingStep2 from "pages/onboarding/_pages/Step2";
import OnboardingStep3 from "pages/onboarding/_pages/Step3";
import OnboardingStep4 from "pages/onboarding/_pages/Step4";
import OnboardingStepPersonalDataUSA from "pages/onboarding/_pages/StepPersonalDataUSA";
import OnboardingStep5 from "pages/onboarding/_pages/Step5";
import OnboardingStepAddressUSA from "pages/onboarding/_pages/StepAddressUSA";
import OnboardingStep6 from "pages/onboarding/_pages/Step6";
import OnboardingStepOccupationUSA from "pages/onboarding/_pages/StepOccupationUSA";
import OnboardingStepPEP from "pages/onboarding/_pages/StepPEP";
import OnboardingInvitationCodeSendFail from "pages/onboarding/_components/InvitationCodeSendFail";
import EnrollmentAssociateStep1 from "pages/enrollment/AssociateStep1";
import EnrollmentAssociateStep2 from "pages/enrollment/AssociateStep2";
import EnrollmentAssociateStep3 from "pages/enrollment/AssociateStep3";
import EnrollmentIndex from "pages/enrollment/Index";
import EnrollmentError from "pages/enrollment/Error";
import EnrollmentStep1 from "pages/enrollment/Step1";
import EnrollmentStep3Part1 from "pages/enrollment/Step3Part1";
import EnrollmentStep3Part3 from "pages/enrollment/Step3Part3";
import EnrollmentStep3Part4 from "pages/enrollment/Step3Part4";
import EnrollmentStepIRS from "pages/enrollment/StepIRS";
import EnrollmentSuccess from "pages/enrollment/Success";
import RequestInvitationCode from "pages/enrollment/RequestInvitationCode";
import RequestInvitationCodeSuccess from "pages/enrollment/RequestInvitationCodeSuccess";
import PrivateRoutes from "routes/PrivateRoutes";
import PrivacyPolicy from "pages/_components/PrivacyPolicy";
import TermsAndConditions from "pages/_components/TermsAndConditions";
import SupportInfo from "pages/_components/SupportInfo";
import { selectors as loginSelectors } from "reducers/login";
import { REGION_USA } from "constants.js";
import StepSelectSecuritySeal from "pages/onboarding/StepSelectSecuritySeal";
import StepStart from "pages/onboarding/StepStart";
import StepStartOnMobile from "pages/onboarding/StepStartOnMobile";
import StepInvitationCode from "pages/onboarding/StepInvitationCode/StepInvitationCode";
import StepSmsWithInvitation from "pages/onboarding/StepSmsWithInvitation/StepSmsWithInvitation";
import StepStartEnrolledUser from "pages/onboarding/StepStartEnrolledUser";
import StepVerifyUsername from "pages/onboarding/StepVerifyUserCredentials/StepVerifyUsername";
import StepVerifyPassword from "pages/onboarding/StepVerifyUserCredentials/StepVerifyPassword";
import StepFinishEnrolledUser from "pages/onboarding/StepFinishEnrolledUser/StepFinishEnrolledUser";
// eslint-disable-next-line max-len
import StepVerifyUserCredentialsSuccess from "pages/onboarding/StepVerifyUserCredentials/StepVerifyUserCredentialsSuccess";
import StepVerifyUsernameMigration from "pages/migration/StepVerifyUserCredentials/StepVerifyUsername";
import StepVerifyPasswordMigration from "pages/migration/StepVerifyUserCredentials/StepVerifyPassword";
import StepFinishEnrolledUserMigration from "pages/migration/StepFinishEnrolledUser/StepFinishEnrolledUser";

import StepSelectEnrolledUserRole from "pages/onboarding/StepSelectEnrolledUserRole/StepSelectEnrolledUserRole";
import StepEmail from "pages/onboarding/StepEmail/StepEmail";
import StepCUIT from "pages/onboarding/StepCUIT/StepCUIT";
import StepScanDocument from "pages/onboarding/StepScanDocument/StepScanDocument";
import StepScanDocumentTerms from "pages/onboarding/StepScanDocument/StepScanDocumentTerms";
import StepScanDocumentSuccess from "pages/onboarding/StepScanDocument/StepScanDocumentSuccess";
import StepScanDocumentMigration from "pages/migration/StepScanDocument/StepScanDocument";
import StepScanDocumentTermsMigration from "pages/migration/StepScanDocument/StepScanDocumentTerms";
import StepScanDocumentSuccessMigration from "pages/migration/StepScanDocument/StepScanDocumentSuccess";
import StepCaptureSelfieMigration from "pages/migration/StepCaptureSelfie/StepCaptureSelfie";
import StepCaptureSelfieSuccessMigration from "pages/migration/StepCaptureSelfie/StepCaptureSelfieSuccess";
import StepPersonalDataMigration from "pages/migration/StepPersonalData/StepPersonalData";

import StepCaptureSelfie from "pages/onboarding/StepCaptureSelfie/StepCaptureSelfie";
import StepCaptureSelfieSuccess from "pages/onboarding/StepCaptureSelfie/StepCaptureSelfieSuccess";
import StepSms from "pages/onboarding/StepSms/StepSms";
import StepEmailSuccess from "pages/onboarding/StepEmail/StepEmailSuccess";
import StepSmsSuccess from "pages/onboarding/StepSms/StepSmsSuccess";
import StepSmsMigration from "pages/migration/StepSms/StepSms";
import StepSmsSuccessMigration from "pages/migration/StepSms/StepSmsSuccess";
import StepUserFinish from "pages/onboarding/StepUserFinish";
import StepPersonalData from "pages/onboarding/StepPersonalData/StepPersonalData";
import StepRegulatoryDataSuccess from "pages/onboarding/StepRegulatoryData/StepRegulatoryDataSuccess";
import StepUser from "pages/onboarding/StepUser/StepUser";
import StepPassword from "pages/onboarding/StepPassword/StepPassword";
import CreditBillsTransactionPage from "pages/creditBills/TransactionIndex";
import ServicePaymentsTransactionPage from "pages/servicePayments/TransactionIndex";
import ContactTransactionPage from "pages/frequentDestination/TransactionPage";
import SolicitDebinTransactionPage from "pages/debinPayments/SolicitDebin/SolicitDebinTransactionPage";
import SuccessCancelRenewalPage from "pages/deposits/DepositCancelRenewal/SuccessCancelRenewalPage";
import PendingCancelRenewalPage from "pages/deposits/DepositCancelRenewal/PendingCancelRenewalPage";
import PendingTransactionPage from "pages/accounts/PendingTransactionPage";
import SuccessTransactionPage from "pages/accounts/SuccessTransactionPage";
import TransferTransactionPage from "pages/transfers/TransactionIndex";
import MassiveEcheckTransactionPage from "pages/echeck/MassiveEcheck/massiveEcheckTransactionPage";
import ActionsTransactionPage from "pages/debinPayments/DebinActions/ActionsTransactionPage";
import DeclineDebinTransactionPage from "pages/debinPayments/DeclineDebinTransactionPage";
import EmitEcheckTransactionPage from "pages/echeck/EmitEcheck/TransactionPage";
import CashOutTransactionPage from "pages/accounts/cashOut/CashOutTransactionPage";
import NewDepositSuccessTransaction from "pages/deposits/NewDepositSuccessTransaction";
import NewDepositPendingTransaction from "pages/deposits/NewDepositPendingTransaction";
import EcheckRequestAvalPage from "pages/echeck/SolicitAval/components/SolicitSumaryPage";
import EcheckUpdateAvalPage from "pages/echeck/ActionsAval/components/ActionsSumaryPage";
import EmitDebinTransactionPage from "pages/debinPayments/AddRecurence/TransactionPage";
import ActionTransactionPage from "pages/debinPayments/ScheduledDebin/ActionTransactionPage";
import PendingAgreementPage from "pages/accounts/AgreementRequestPage/PendingAgreementPage";
import SuccessAgreementPage from "pages/accounts/AgreementRequestPage/SuccessAgreementPage";
import EcheckRequestTransactionPage from "pages/echeck/EcheckRequest/TransactionPage";
import LotPaymentTransactionPage from "pages/payThirdParties/NewLotPayment/TransactionPage";
import UnsecuredLoanTransactionPage from "pages/loans/unsecuredLoans/UnsecuredLoanTransactionPage";
import CancelacionAnticipadaTicket from "pages/loans/_components/CancelacionAnticipadaTicket";
import NewCheckbookSuccessPage from "pages/checks/NewCheckbookSuccessPage";
import PendingBackofficeApprovePage from "pages/checks/PendingBackofficeApprovePage";
import PendingUserSignaturesPage from "pages/checks/PendingUserSignaturesPage";
import CesionEcheckTransactionPage from "pages/echeck/EmitCesion/TransactionPage";
import EndorseEcheckTransactionPage from "pages/echeck/EndorseEcheck/TransactionPage";
import TransactionPage from "pages/echeck/EcheckActions/TransactionPage";

import StepUserMigration from "pages/migration/StepUser/StepUser";
import StepPasswordMigration from "pages/migration/StepPassword/StepPassword";
import StepSelectSecuritySealMigration from "pages/migration/StepSelectSecuritySeal/StepSelectSecuritySeal";
import StepUserFinishMigration from "pages/migration/StepUserFinish/StepUserFinish";
import LoginStep7 from "pages/login/LoginStep7";
import CustomLoanTransactionPage from "pages/loans/customLoans/CustomLoanTransactionPage";
import MepTransactionPage from "pages/transfers/mep/TransactionPage";
import VepPaymentTransactionPage from "pages/afipPaymentLink/NewVepPayment/VepPaymentTransactionPage";
// eslint-disable-next-line max-len
import ServicesPaymentTransactionPage from "pages/afipPaymentLink/afipServices/newPayment/ServicesPaymentTransactionPage";
import AddAccountTransactionPage from "pages/investmentFunds/accounts/AddAccountTransactionPage";
import ComexTransactionPage from "pages/comex/TransactionPage";
import NewPaymentTransactionPage from "pages/afipPaymentLink/servicesPayment/NewPaymentTransactionPage";
import LinkServiceTransactionPage from "pages/afipPaymentLink/servicesPayment/linkedService/LinkServiceTransactionPage";
import DirectDebitTransactionPage from "pages/directDebit/DirectDebitTransactionPage";
import ResetExpiredPassword from "pages/resetExpiredPassword/ResetExpiredPassword";
import DebinChargebackTransactionPage from "pages/debinPayments/ChargeBack/Tickets/DebinChargebackTransactionPage";
import StepScanDocumentBack from "pages/onboarding/StepScanDocument/StepScanDocumentBack";
import StepScanDocumentMigrationBack from "pages/migration/StepScanDocument/StepScanDocumentBack";
import RequestCacTransactionPage from "pages/echeck/RequestCac/TransactionPage";
import AcceptReturnTransactionPage from "pages/echeck/AcceptReturnRejected/TransactionPage";
import TermsAndConditionsLastStep from "../pages/onboarding/StepUserFinish/TermsAndConditionsLastStep";
import PayrollTransactionPage from "../pages/payroll/PayrollTransactionPage";
import payDebinPage from "../pages/debinPayments/DebinActions/PayDebinSumaryPage";

class Routes extends Component {
    static propTypes = {
        hasActiveSession: bool,
        // isMobile: bool.isRequired,
        location: shape({
            pathname: string,
        }).isRequired,
        activeRegion: string,
        isDesktop: bool.isRequired,
    };

    static defaultProps = {
        hasActiveSession: false,
        activeRegion: "",
    };

    shouldComponentUpdate(nextProps) {
        const {
            location: { pathname },
            hasActiveSession,
        } = this.props;
        // With oauth, the login step 2 sets an active session before routing to step3
        // Changing the value of active session triggers an additional transition animation
        // This avoids that unnecessary re-render
        if (pathname.includes("loginStep2")) {
            if (!hasActiveSession && nextProps.hasActiveSession) {
                return false;
            }
        }
        return true;
    }

    render() {
        const { hasActiveSession, activeRegion, isDesktop } = this.props;

        return (
            <Switch>
                <Route exact path="/serverError" component={ServerError} />
                <Route exact path="/error" component={Error} />

                <ExternalLayout exact path="/assistant" component={AssistantLogin} />
                <ExternalLayout exact path="/assistant/:pageToken" component={AssistantLogin} />
                <ExternalLayout exact path="/" component={OnboardingPage} />
                <ExternalLayout exact path="/loginStep2" component={LoginStep2} />
                <ExternalLayout exact path="/loginRegister" component={LoginRegister} />
                <ExternalLayout exact path="/loginStep3" component={LoginStep3} />
                <ExternalLayout exact path="/loginStep4" component={LoginStep4} />
                <ExternalLayout exact path="/loginStep5" component={LoginAssistantStep} />
                <ExternalLayout exact path="/loginStep6" component={LoginStep6} />
                <ExternalLayout exact path="/loginStep7" component={LoginStep7} />

                <ExternalLayout exact path="/recovery/:recoveryType/step1" component={RecoveryPassStep1} />
                <ExternalLayout exact path="/recovery/:recoveryType/step2" component={RecoveryPassStep2} />
                <ExternalLayout exact path="/recovery/:recoveryType/step3" component={RecoveryPassStep3} />
                <ExternalLayout exact path="/recovery/:recoveryType/step4" component={RecoveryPassStep4} />

                <EnrollmentLayout exact path="/resetExpiredPasswordStep1" component={ResetExpiredPassword} />

                <ExternalLayout exact path="/session/expiredByMaxAttempts" component={ExpiredByMaxAttempts} />
                <BackofficeLayout exact path="/forms/backoffice/ticket" component={BackofficeTransaction} />

                {/* TICKETS  */}

                {/* BILLS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/creditBills/:action/pending/:id"
                    component={CreditBillsTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/creditBills/:action/success/:id"
                    component={CreditBillsTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/creditBills/:action/failed/:id"
                    component={CreditBillsTransactionPage}
                />

                {/* SERVICE PAYMENTS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/payments/:type/success/:id"
                    component={ServicePaymentsTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/payments/:type/pending/:id"
                    component={ServicePaymentsTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/payments/:type/failed/:id"
                    component={ServicePaymentsTransactionPage}
                />

                {/* CONTACTS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/contactDestination/success/:id/"
                    component={ContactTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/contactDestination/pending/:id/"
                    component={ContactTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/contactDestination/failed/:id/"
                    component={ContactTransactionPage}
                />

                <BackofficeLayout
                    exact
                    path="/backoffice/contactDestination/modify/pending/:id"
                    component={ContactTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/contactDestination/modify/success/:id"
                    component={ContactTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/contactDestination/modify/failed/:id"
                    component={ContactTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/contactDestination/delete/pending/:id"
                    component={ContactTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/contactDestination/delete/success/:id"
                    component={ContactTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/contactDestination/delete/failed/:id"
                    component={ContactTransactionPage}
                />

                {/* DEBIN */}
                <BackofficeLayout
                    exact
                    path="/backoffice/debinPayments/solicitDebin/success/:id/"
                    component={SolicitDebinTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debinPayments/solicitDebin/pending/:id/"
                    component={SolicitDebinTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debinPayments/solicitDebin/failed/:id"
                    component={SolicitDebinTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debinPayments/action/action/pending/:id"
                    component={ActionsTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debinPayments/action/action/success/:id"
                    component={ActionsTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debinPayments/reject/success/:id"
                    component={DeclineDebinTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debinPayments/reject/pending/:id"
                    component={DeclineDebinTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debinPayments/reject/failed/:id"
                    component={DeclineDebinTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debin/emit/pending/:id"
                    component={EmitDebinTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debin/emit/success/:id"
                    component={EmitDebinTransactionPage}
                />
                <BackofficeLayout exact path="/backoffice/debin/emit/failed/:id" component={EmitDebinTransactionPage} />

                <BackofficeLayout
                    exact
                    path="/backoffice/scheduledDebin/:action/transaction/:id"
                    component={ActionTransactionPage}
                />

                <BackofficeLayout
                    exact
                    path="/backoffice/debin/chargeBack/pending/:id"
                    component={DebinChargebackTransactionPage}
                />

                <BackofficeLayout
                    exact
                    path="/backoffice/debin/chargeBack/cancelled/:id"
                    component={DebinChargebackTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/debin/chargeBack/failed/:id"
                    component={DebinChargebackTransactionPage}
                />

                <BackofficeLayout exact path="/backoffice/debinPayments/pay/success/:id" component={payDebinPage} />
                <BackofficeLayout exact path="/backoffice/debinPayments/pay/failed/:id" component={payDebinPage} />

                {/* DEPOSITS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/deposits/cancelRenewal/successTransaction/:id"
                    component={SuccessCancelRenewalPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/deposits/cancelRenewal/pendingTransaction/:id"
                    component={PendingCancelRenewalPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/deposits/pendingTransaction/:id"
                    component={NewDepositPendingTransaction}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/deposits/successTransaction/:id"
                    component={NewDepositSuccessTransaction}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/deposits/failedTransaction/:id"
                    component={NewDepositSuccessTransaction}
                />

                {/* ACCOUNTS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/accounts/pendingTransaction/:id"
                    component={PendingTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/accounts/cancelledTransaction/:id"
                    component={PendingTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/accounts/successTransaction/:id"
                    component={SuccessTransactionPage}
                />
                <BackofficeLayout exact path="/backoffice/accounts/failed/:id" component={SuccessTransactionPage} />
                <BackofficeLayout
                    exact
                    path="/backoffice/accounts/agreements/pendingTransaction/:id"
                    component={PendingAgreementPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/accounts/agreements/successTransaction/:id"
                    component={SuccessAgreementPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/accounts/agreements/pendingTransaction/:id"
                    component={PendingAgreementPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/accounts/agreements/failedTransaction/:id"
                    component={SuccessAgreementPage}
                />

                {/* TRANSFERS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/transfers/:type/success/:id"
                    component={TransferTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/transfers/:type/pending/:id"
                    component={TransferTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/transfers/:type/failed/:id"
                    component={TransferTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/transfers/:type/schedule/:id"
                    component={TransferTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/transfers/:type/draft/:id"
                    component={TransferTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/transfers/:type/cancelled/:id"
                    component={TransferTransactionPage}
                />

                {/* LOT PAYMENTS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/lotPayments/newPayment/success/:id"
                    component={LotPaymentTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/lotPayments/newPayment/pending/:id"
                    component={LotPaymentTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/lotPayments/newPayment/failed/:id"
                    component={LotPaymentTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/lotPayments/newPayment/processing/:id"
                    component={LotPaymentTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/lotPayments/newPayment/cancelled/:id"
                    component={LotPaymentTransactionPage}
                />

                {/* CHECKS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/checks/pendingBackofficeApprove/:id"
                    component={PendingBackofficeApprovePage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/checks/pendingUserSignatures/:id"
                    component={PendingUserSignaturesPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/checks/successTransaction/:id"
                    component={NewCheckbookSuccessPage}
                />

                {/* ECHEQS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/emit/pending/:id"
                    component={EmitEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/emit/success/:id"
                    component={EmitEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/emit/failed/:id"
                    component={EmitEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/aval/solicit/pending/:id"
                    component={EcheckRequestAvalPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/aval/solicit/success/:id"
                    component={EcheckRequestAvalPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/aval/solicit/failed/:id"
                    component={EcheckRequestAvalPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/aval/update/pending/:id"
                    component={EcheckUpdateAvalPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/aval/update/success/:id"
                    component={EcheckUpdateAvalPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/aval/update/failed/:id"
                    component={EcheckUpdateAvalPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/requestAmount/pending/:id"
                    component={EcheckRequestTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/requestAmount/success/:id"
                    component={EcheckRequestTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/cesion/pending/:id"
                    component={CesionEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/cesion/success/:id"
                    component={CesionEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/cesion/cancelled/:id"
                    component={CesionEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/cesion/failed/:id"
                    component={CesionEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/cesion/transaction/:id"
                    component={CesionEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/endorse/pending/:id"
                    component={EndorseEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/endorse/success/:id"
                    component={EndorseEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/endorse/failed/:id"
                    component={EndorseEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/endorse/cancelled/:id"
                    component={EndorseEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/cancelendorse/success/:id"
                    component={EndorseEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/cancelendorse/failed/:id"
                    component={EndorseEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/cancelendorse/pending/:id"
                    component={EndorseEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/cancelendorse/cancelled/:id"
                    component={EndorseEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/transaction/pending/:id"
                    component={TransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/transaction/success/:id"
                    component={TransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/transaction/failed/:id"
                    component={TransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/action/transaction/cancelled/:id"
                    component={TransactionPage}
                />

                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/cac/pending/:id"
                    component={RequestCacTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/cac/success/:id"
                    component={RequestCacTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/cac/cancelled/:id"
                    component={RequestCacTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/cac/failed/:id"
                    component={RequestCacTransactionPage}
                />

                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/rejected/return/accept/failed/:id"
                    component={AcceptReturnTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/rejected/return/accept/pending/:id"
                    component={AcceptReturnTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/rejected/return/accept/cancelled/:id"
                    component={AcceptReturnTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/echecks/rejected/return/accept/success/:id"
                    component={AcceptReturnTransactionPage}
                />

                {/* MASSIVE ECHEQS */}
                <BackofficeLayout
                    exact
                    path="/backoffice/massiveEchecks/newEcheq/success/:id"
                    component={MassiveEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/massiveEchecks/newEcheq/pending/:id"
                    component={MassiveEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/massiveEchecks/newEcheq/failed/:id"
                    component={MassiveEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/massiveEchecks/newEcheq/processing/:id"
                    component={MassiveEcheckTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/massiveEchecks/newEcheq/schedule/:id"
                    component={MassiveEcheckTransactionPage}
                />

                {/* CASHOUT */}
                <BackofficeLayout exact path="/backoffice/cashOut/transaction/:id" component={CashOutTransactionPage} />

                {/* Unsecured loan */}
                <BackofficeLayout
                    exact
                    path="/backoffice/requestUnsecuredLoan/transaction/:id"
                    component={UnsecuredLoanTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/requestCustomLoan/transaction/:id"
                    component={CustomLoanTransactionPage}
                />
                <BackofficeLayout
                    exact
                    path="/backoffice/loans/cancelacionAnticipadaTicket/:id"
                    component={CancelacionAnticipadaTicket}
                />

                <BackofficeLayout exact path="/backoffice/mep/transaction/:id" component={MepTransactionPage} />
                <BackofficeLayout exact path="/backoffice/comex/transaction/:id" component={ComexTransactionPage} />

                {/* Payments with LINK */}

                <BackofficeLayout
                    exact
                    path="/backoffice/vepPayments/newPayment/transaction/:id"
                    component={VepPaymentTransactionPage}
                />

                <BackofficeLayout
                    exact
                    path="/backoffice/arcaServices/newPayment/transaction/:id"
                    component={ServicesPaymentTransactionPage}
                />

                <BackofficeLayout
                    exact
                    path="/backoffice/newServicePayment/transaction/:id"
                    component={NewPaymentTransactionPage}
                />

                <BackofficeLayout
                    exact
                    path="/backoffice/linkService/transaction/:id"
                    component={LinkServiceTransactionPage}
                />

                {/* Investments Funds */}
                <BackofficeLayout
                    exact
                    path="/backoffice/investmentFunds/accounts/add/transaction/:id"
                    component={AddAccountTransactionPage}
                />

                {/* DIRECT DEBIT */}
                <BackofficeLayout
                    exact
                    path="/backoffice/directDebit/transaction/:id"
                    component={DirectDebitTransactionPage}
                />

                {/* MASS PAYROLL */}
                <BackofficeLayout
                    exact
                    path="/backoffice/massPayroll/transaction/:id"
                    component={PayrollTransactionPage}
                />

                <ExternalLayout exact path="/languageSelection" component={LanguageSelection} />
                <ExternalLayout exact path="/regionSelection" component={RegionSelection} />

                <EnrollmentLayout exact path="/noUser" component={NoUser} />

                <EnrollmentLayout step={7} exact path="/enrollment" component={EnrollmentIndex} showBack />
                <EnrollmentLayout
                    step={7}
                    exact
                    path="/enrollment/code/:code/:lang/:reg?"
                    component={EnrollmentIndex}
                    showBack
                />
                <EnrollmentLayout exact path="/enrollment/error" component={EnrollmentError} />
                <EnrollmentLayout exact path="/enrollment/associate/step1" component={EnrollmentAssociateStep1} />
                <EnrollmentLayout exact path="/enrollment/associate/step2" component={EnrollmentAssociateStep2} />
                <EnrollmentLayout exact path="/enrollment/associate/step3" component={EnrollmentAssociateStep3} />
                <EnrollmentLayout
                    exact
                    path="/enrollment/requestInvitationCode"
                    component={RequestInvitationCode}
                    mustGobackWithClose
                />
                <EnrollmentLayout
                    exact
                    path="/enrollment/requestInvitationCode/success"
                    component={RequestInvitationCodeSuccess}
                />
                <EnrollmentLayout step={8} exact path="/enrollment/step1" component={EnrollmentStep1} />
                <EnrollmentLayout step={9} exact path="/enrollment/step3part1" component={EnrollmentStep3Part1} />
                <EnrollmentLayout
                    step={11}
                    exact
                    path="/enrollment/step3part3"
                    component={EnrollmentStep3Part3}
                    showBack
                />
                <EnrollmentLayout
                    step={12}
                    exact
                    path="/enrollment/step3part4"
                    component={EnrollmentStep3Part4}
                    showBack
                />
                <EnrollmentLayout exact path="/enrollment/stepIRS" component={EnrollmentStepIRS} />

                <EnrollmentLayout exact path="/enrollment/success" component={EnrollmentSuccess} />

                <ExternalLayout
                    exact
                    path="/onboarding/stepStartOnMobile"
                    component={StepStartOnMobile}
                    className={isDesktop ? "fifty-fifty-layout" : "full-height"}
                />

                <EnrollmentLayout exact path="/onboarding/stepStart" component={StepStart} />
                <EnrollmentLayout exact path="/onboarding/stepInvitationCode" component={StepInvitationCode} />
                <EnrollmentLayout exact path="/onboarding/stepStartEnrolledUser" component={StepStartEnrolledUser} />
                <EnrollmentLayout exact path="/onboarding/stepVerifyUsername" component={StepVerifyUsername} />
                <EnrollmentLayout exact path="/onboarding/stepVerifyPassword" component={StepVerifyPassword} />
                <EnrollmentLayout
                    exact
                    path="/onboarding/stepVerifyUserCredentialsSuccess"
                    component={StepVerifyUserCredentialsSuccess}
                />
                <EnrollmentLayout
                    exact
                    path="/onboarding/stepSelectEnrolledUserRole"
                    component={StepSelectEnrolledUserRole}
                />
                <EnrollmentLayout
                    exact
                    path="/onboarding/stepFinishUserValidation"
                    component={StepFinishEnrolledUser}
                />
                <EnrollmentLayout exact path="/onboarding/stepCUIT" component={StepCUIT} />
                <EnrollmentLayout exact path="/onboarding/stepEmail" component={StepEmail} />
                <EnrollmentLayout exact path="/onboarding/stepEmailSuccess" component={StepEmailSuccess} />
                <EnrollmentLayout exact path="/onboarding/stepSmsWithInvitation" component={StepSmsWithInvitation} />
                <EnrollmentLayout exact path="/onboarding/stepSms" component={StepSms} />
                <EnrollmentLayout exact path="/onboarding/stepSmsSuccess" component={StepSmsSuccess} />
                <EnrollmentLayout exact path="/onboarding/stepSelectSecuritySeal" component={StepSelectSecuritySeal} />
                <EnrollmentLayout exact path="/onboarding/stepUserFinish" component={StepUserFinish} />
                <EnrollmentLayout
                    exact
                    path="/onboarding/stepUserFinish/termsAndConditions"
                    component={TermsAndConditionsLastStep}
                />
                <EnrollmentLayout
                    exact
                    path="/migration/stepFinishUserValidation/termsAndConditions"
                    component={TermsAndConditionsLastStep}
                />

                <EnrollmentLayout exact path="/onboarding/stepPersonalData" component={StepPersonalData} />
                <EnrollmentLayout
                    exact
                    path="/onboarding/stepRegulatoryDataSuccess"
                    component={StepRegulatoryDataSuccess}
                />
                <EnrollmentLayout exact path="/onboarding/stepUser" component={StepUser} />
                <EnrollmentLayout exact path="/onboarding/stepPassword" component={StepPassword} />
                <EnrollmentLayout exact path="/onboarding/step0" component={OnboardingStep0} />

                <EnrollmentLayout exact path="/onboarding/stepScanDocument" component={StepScanDocument} />
                <EnrollmentLayout exact path="/onboarding/stepScanDocumentBack" component={StepScanDocumentBack} />
                <EnrollmentLayout exact path="/onboarding/stepScanDocumentTerms" component={StepScanDocumentTerms} />
                <EnrollmentLayout
                    exact
                    path="/onboarding/stepScanDocumentSuccess"
                    component={StepScanDocumentSuccess}
                />
                <EnrollmentLayout exact path="/onboarding/stepCaptureSelfie" component={StepCaptureSelfie} />
                <EnrollmentLayout
                    exact
                    path="/onboarding/stepCaptureSelfieSuccess"
                    component={StepCaptureSelfieSuccess}
                />

                <EnrollmentLayout exact path="/onboarding/stepCIP" component={OnboardingStepCIP} showBack />
                <EnrollmentLayout step={1} exact path="/onboarding/step1" component={OnboardingStep1} showBack />
                <EnrollmentLayout
                    step={2}
                    camera="landscape"
                    exact
                    path="/onboarding/step2/front"
                    transition="transition-change-feature"
                    component={OnboardingStep2}
                    showBack
                />
                <EnrollmentLayout exact path="/tokenVirtual" component={TokenVirtual} />
                <EnrollmentLayout
                    step={2}
                    exact
                    camera="landscape"
                    path="/onboarding/step2/front/processing"
                    transition="transition-change-feature"
                    component={Processing}
                />
                <EnrollmentLayout
                    step={2}
                    camera="landscape"
                    exact
                    path="/onboarding/step2/back"
                    transition="transition-change-feature"
                    component={OnboardingStep2}
                />
                <EnrollmentLayout
                    step={2}
                    exact
                    camera="landscape"
                    path="/onboarding/step2/back/processing"
                    transition="transition-change-feature"
                    component={Processing}
                />
                <EnrollmentLayout
                    step={3}
                    camera
                    exact
                    path="/onboarding/step3"
                    transition="transition-change-feature"
                    component={OnboardingStep3}
                />
                <EnrollmentLayout
                    step={3}
                    exact
                    path="/onboarding/step3/processing"
                    transition="transition-change-feature"
                    component={Processing}
                />
                {activeRegion !== REGION_USA ? (
                    <EnrollmentLayout step={4} exact path="/onboarding/step4" component={OnboardingStep4} />
                ) : (
                    <EnrollmentLayout
                        step={4}
                        exact
                        path="/onboarding/step4"
                        component={OnboardingStepPersonalDataUSA}
                    />
                )}
                {activeRegion !== REGION_USA ? (
                    <EnrollmentLayout step={5} exact path="/onboarding/step5" component={OnboardingStep5} showBack />
                ) : (
                    <EnrollmentLayout
                        step={5}
                        exact
                        path="/onboarding/step5"
                        component={OnboardingStepAddressUSA}
                        showBack
                    />
                )}
                {activeRegion !== REGION_USA ? (
                    <EnrollmentLayout step={6} exact path="/onboarding/step6" component={OnboardingStep6} showBack />
                ) : (
                    <EnrollmentLayout
                        step={6}
                        exact
                        path="/onboarding/step6"
                        component={OnboardingStepOccupationUSA}
                        showBack
                    />
                )}
                <EnrollmentLayout step={6} exact path="/onboarding/stepPEP" component={OnboardingStepPEP} showBack />
                <EnrollmentLayout exact path="/onboarding/*/error" component={OnboardingError} />
                <EnrollmentLayout
                    exact
                    path="/onboarding/SafariSuggestionPage"
                    component={OnboardingSafariSuggestionPage}
                />
                <EnrollmentLayout
                    exact
                    path="/onboarding/invitation/fail"
                    component={OnboardingInvitationCodeSendFail}
                />
                <EnrollmentLayout
                    exact
                    path="/onboarding/termsAndConditions"
                    component={() => <TermsAndConditions fromOnboarding />}
                    mustGobackWithClose
                />

                <EnrollmentLayout exact path="/migration/stepSms" component={StepSmsMigration} />
                <EnrollmentLayout exact path="/migration/stepSmsSuccess" component={StepSmsSuccessMigration} />
                <EnrollmentLayout exact path="/migration/stepScanDocument" component={StepScanDocumentMigration} />
                <EnrollmentLayout
                    exact
                    path="/migration/stepScanDocumentBack"
                    component={StepScanDocumentMigrationBack}
                />
                <EnrollmentLayout
                    exact
                    path="/migration/stepScanDocumentTerms"
                    component={StepScanDocumentTermsMigration}
                />
                <EnrollmentLayout
                    exact
                    path="/migration/stepScanDocumentSuccess"
                    component={StepScanDocumentSuccessMigration}
                />
                <EnrollmentLayout exact path="/migration/StepCaptureSelfie" component={StepCaptureSelfieMigration} />
                <EnrollmentLayout
                    exact
                    path="/migration/StepCaptureSelfieSuccess"
                    component={StepCaptureSelfieSuccessMigration}
                />
                <EnrollmentLayout exact path="/migration/stepPersonalData" component={StepPersonalDataMigration} />
                <EnrollmentLayout exact path="/migration/stepUser" component={StepUserMigration} />
                <EnrollmentLayout exact path="/migration/stepPassword" component={StepPasswordMigration} />
                <EnrollmentLayout
                    exact
                    path="/migration/stepSelectSecuritySeal"
                    component={StepSelectSecuritySealMigration}
                />
                <EnrollmentLayout exact path="/migration/stepUserFinishMigration" component={StepUserFinishMigration} />

                <EnrollmentLayout exact path="/migration/stepVerifyUsername" component={StepVerifyUsernameMigration} />
                <EnrollmentLayout exact path="/migration/stepVerifyPassword" component={StepVerifyPasswordMigration} />
                <EnrollmentLayout
                    exact
                    path="/migration/stepFinishUserValidation"
                    component={StepFinishEnrolledUserMigration}
                />

                {!hasActiveSession && <ExternalLayout exact path="/privacyPolicy" component={PrivacyPolicy} />}
                {!hasActiveSession && (
                    <ExternalLayout exact path="/termsAndConditions" component={TermsAndConditions} />
                )}
                {!hasActiveSession && <ExternalLayout exact path="/support" component={SupportInfo} />}

                <ProductRequestLayout exact path="/products/creditCardRequest" component={ProductRequest} />
                <ProductRequestLayout
                    exact
                    path="/products/creditCardRequest/showEmailVerification"
                    component={CreditCardStep1}
                />
                <ProductRequestLayout
                    exact
                    path="/products/creditCardRequest/emailVerification"
                    component={CreditCardStep2}
                />
                <ProductRequestLayout
                    exact
                    path="/products/onboarding/invitation/fail"
                    component={OnboardingInvitationCodeSendFail}
                />

                <PrivateRoutes />
            </Switch>
        );
    }
}

const mapStateToProps = (state) => ({
    hasActiveSession: sessionSelectors.isLoggedIn(state),
    activeRegion: loginSelectors.getRegion(state),
});

export default withRouter(connect(mapStateToProps)(resizableRoute(Routes)));
